import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-add-issuer',
  templateUrl: './add-issuer.component.html',
  styleUrls: ['./add-issuer.component.css']
})
export class AddIssuerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/add-issuer/add-issuer.component.ts